// src/redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import { getGlobalAccessToken } from "../context/AuthContext";

import savedSearchReducer from "./savedSearchSlice";
import searchReducer from "./searchSlice";
import subscriptionReducer from "./subscriptionSlice";
import profileReducer from "./profileSlice";
import notificationReducer from "./notificationSlice";
import trendingReducer from "./trendingSlice";
import invitesReducer from "./inviteSlice";
import redemptionsReducer from "./redemptionsSlice";
import offersReducer from "./offersSlice";
import bookingsReducer from "./bookingsSlice";
import campaignsReducer from "./campaignsSlice";
import advisorReducer from "./advisorSlice";
import accountSettingsReducer from "./accountSettingsSlice";
import influencerDetailsReducer from "./influencerDetailsSlice";
import slugLookupReducer from "./slugLookupSlice";
import discoveryReducer from "./discoverySlice";
import reactionsReducer from "./reactionsSlice";
import eventsReducer from "./eventsSlice";
import unlocksReducer from "./unlocksSlice";
import searchHistoryReducer from "./searchHistorySlice";
import usageReducer from "./usageSlice";
import entitlementsReducer from "./entitlementsSlice";
import savedCreatorsReducer from "./savedCreatorsSlice";
import preferencesReducer from "./preferencesSlice";
import creatorWorkflowReducer from "./creatorWorkflowSlice";
import creatorsCrmReducer from "./creatorsCrmSlice";
import demandSuggestionsReducer from "./demandSuggestionsSlice";
import creatorRequestsReducer from "./creatorRequestSlice";
import creatorAdvisorReducer from "./creatorAdvisorSlice";


const store = configureStore({
  reducer: {
    influencerDetails: influencerDetailsReducer,
    savedSearch: savedSearchReducer,
    search: searchReducer,
    subscription: subscriptionReducer,
    profile: profileReducer,
    notifications: notificationReducer,
    trending: trendingReducer,

    offers: offersReducer,
    campaigns: campaignsReducer,
    advisor: advisorReducer,
    invites: invitesReducer,
    redemptions: redemptionsReducer,
    bookings: bookingsReducer,

    accountSettings: accountSettingsReducer,
    slugLookup: slugLookupReducer,
    discovery: discoveryReducer,
    reactions: reactionsReducer,
    events: eventsReducer,
    unlocks: unlocksReducer,
    searchHistory: searchHistoryReducer,
    usage: usageReducer,
    entitlements: entitlementsReducer,
    preferences: preferencesReducer,
    savedCreators: savedCreatorsReducer,
    creatorWorkflow: creatorWorkflowReducer,
    creatorsCrm: creatorsCrmReducer,
    demandSuggestions: demandSuggestionsReducer,

    creatorRequests: creatorRequestsReducer,
    creatorAdvisor: creatorAdvisorReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: { extraArgument: { getAccessToken: getGlobalAccessToken } },
      serializableCheck: false,
    }),
});

export default store;